"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const buildInFunctions_1 = require("../buildInFunctions");
const error_1 = require("../error");
class FunctionManager {
    constructor() {
        this.userFunctions = new Map();
        this.buildFunctions = buildInFunctions_1.BuildInFunctions;
    }
    assignment(name, functionArguments, programAst) {
        this.userFunctions.set(name, {
            arguments: functionArguments,
            function: programAst,
        });
    }
    reference(name) {
        if (this.buildFunctions[name]) {
            return Object.assign(Object.assign({}, this.buildFunctions[name]), { type: 'build' });
        }
        else {
            const func = this.userFunctions.get(name);
            if (func === undefined) {
                throw new error_1.NullReferenceFunctionError(`${name}`);
            }
            return Object.assign(Object.assign({}, this.userFunctions.get(name)), { type: 'user' });
        }
    }
    debug() {
        console.group('functions');
        console.info(this.userFunctions);
        console.groupEnd();
    }
}
exports.FunctionManager = FunctionManager;
